import apiPath from '../../../config/api';

const SalesPath = {
    title: "Toko Teknik - Modul Penjualan",
    basePath: "/technique/penjualan",
    newPath: "/technique/penjualan/baru",
    detailPath: "/technique/penjualan/opsi/:id",
    base: apiPath.retailSales,
    baseHistory: apiPath.retailSalesHistory,
    salesExcel: apiPath.retailSalesExcel,
    custFind: apiPath.masterCustFind,
    gnsFind: apiPath.masterGnsFind,
    paymentMethodFind: apiPath.masterPaymentFind,
}

export default SalesPath;
